import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Volume } from '../../../../models/volume';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  selectVolumeById,
  selectVolumeColorMode
} from '../../../../features/volume/volume.selectors';
import { VolumeColorMode } from '../../../../enums/volume';
import { Observable } from 'rxjs';


@Component({
    selector: 'volume-card',
    templateUrl: './volume-card.component.html',
    styleUrls: ['../card.component.scss'],
    standalone: false
})
export class VolumeCardComponent {

  private _volumeId!: string;

  @Input({ required: true })
  set volumeId(value: string) {
    this._volumeId = value;
    this.volume$ = this.store.select(selectVolumeById(value));
  }
  volume$!: Observable<Volume | undefined>;
  private colorMode: VolumeColorMode | undefined;

  constructor(private store: Store) {
    this.initHandleVolumeColorMode();
  }

  private initHandleVolumeColorMode() {
    this.store.select(selectVolumeColorMode)
      .pipe(takeUntilDestroyed())
      .subscribe((colorMode: any) => {
        this.colorMode = colorMode;
      });
  }
}
